import type { CSSProperties } from 'react'

/** Frontend rollout is explicit; the newsletter API can serve additional shops independently. */
const storefronts = {
  101: {
    shopId: 101, name: 'HomeyLove', origin: 'https://homeylove.de',
    style: {} as CSSProperties,
  },
  202: {
    shopId: 202, name: 'LiebesZuhause', origin: 'https://www.liebeszuhause.de',
    style: {
      '--newsletter-ink': '#1f1a17', '--newsletter-muted': '#6f655e',
      '--newsletter-accent': '#ba0063', '--newsletter-accent-hover': '#a30047',
      '--newsletter-focus': '#ba0063', '--newsletter-soft': '#f8eef3',
      '--newsletter-soft-selected': '#f3dfeb', '--newsletter-border-selected': '#ba0063',
      '--newsletter-gradient': 'linear-gradient(115deg,#f8eaf2,#f3f0ed)',
      '--newsletter-home-gradient': 'linear-gradient(115deg,#f6e5ef,#f3f0ed)',
    } as CSSProperties,
  },
} as const

export function getNewsletterStorefront(shopId: number | undefined) {
  return shopId === 101 || shopId === 202 ? storefronts[shopId] : undefined
}

export function newsletterLinkMatchesShop(linkShop: string | undefined, currentShop: number) {
  return Boolean(getNewsletterStorefront(currentShop)) && (linkShop === undefined || linkShop === String(currentShop))
}
